import styled from 'styled-components';

export const ReferContainer = styled.div`
	display: flex;
	justify-content: right;
	margin-top: 30px;
	place-items: end;
	gap: 50px;
`;

export const ReferAmount = styled.span`
	font-weight: 700;
	font-size: 18px;
	line-height: 22px;
	height: 30px;
	display: flex;
	align-items: center;
	color: #5082c2;
`;

export const ResultText = styled.p<{ type: 'danger' | 'info' }>`
	font-style: normal;
	font-weight: 700;
	font-size: 14px;
	line-height: 17px;
	color: ${({ type }) => (type === 'danger' ? '#c22a58' : '#5082C2')};
`;

export const FooterContainer = styled.div`
	display: grid;
	grid-template-columns: 50% 50%;
`;
